<template>
  <div>
    <div v-if="_.size(computedSortClassFilter) > 0" class="quick-filter-container pa-2">
      <v-menu
        open-on-hover
        bottom
        offset-y
        v-for="(quickFilter, index) in computedSortClassFilter"
        :key="'status-box'+index"
        class="mt-2"
      >
        <template v-slot:activator="{ on, attrs }">
          <button
            class="quick-filter-btn"
            :class="_.size(tags) > 0 ? 'active' : ''"
            v-bind="attrs"
            v-on="on"
            @click="handleFilterAllTag"
          >
            <div class="d-flex align-center">
              {{quickFilter.name}}
            </div>
          </button>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in subData()"
            :key="index"
            class="sub-item-filter mb-2"
            :class="checkActive(item) ? 'active' : ''"
            :style="{borderLeft: `2px solid ${item.color}`}"
            @click="clickQuickFilter(item)"
          >
            {{item.name}}
            <span
              class="count mx-2 d-flex align-center justify-center">{{ item.noContact }}</span>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'QuickFilter',
  props: {
    filterForm: {
      type: Object,
      default: () => {},
    },
    contactModuleList: {
      type: Array,
      default: () => [],
    },
    typeHeaderContactModule: {
      type: Array,
      default: () => [],
    },
    priorityConfig: {
      type: Number,
      default: 0,
    },
    typeBlended: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tags: [],
    };
  },
  computed: {
    computedSortClassFilter() {
      if (
        this.typeHeaderContactModule
        && this.typeHeaderContactModule.length > 0
      ) {
        return this.typeHeaderContactModule.filter((e) => !e.typeId);
      } return [];
    },
  },
  methods: {
    ...mapActions('student_care', ['getDataPeriodicallyCareTable', 'getListCallStatusCount']),
    ...mapActions('blended', ['getDataBlendedTutor', 'getListCallStatusBlendedCount']),
    async handleFilterAllTag() {
      const subData = this.subData();
      if (this.tags.length === 0) {
        subData.forEach((e) => {
          this.tags.push(e.id);
        });
      } else {
        this.tags = [];
      }
      this.filterForm.tags = _.cloneDeep(this.tags);
      await this.getData();
    },
    subData() {
      return this.contactModuleList.filter((e) => !e.typeId);
    },
    async getData() {
      if (this.typeBlended === 'tutor' || this.typeBlended === 'extendDuo') {
        this.filterForm.school_level = this.$route.query.schoolLevel;
        await this.getDataBlendedTutor({
          ...this.filterForm,
          typeBlended: this.priorityConfig,
        });
        this.getListCallStatusBlendedCount({
          ...this.filterForm,
          typeBlended: this.priorityConfig,
          school_level: this.$route.query.schoolLevel,
        });
      } else {
        await this.getDataPeriodicallyCareTable({
          ...this.filterForm,
          last_call_time: true,
        });
        this.getListCallStatusCount(this.filterForm);
      }
    },
    async clickQuickFilter(item) {
      this.tags = [];
      this.tags.push(item.id);
      this.filterForm.tags = _.cloneDeep(this.tags);
      await this.getData();
    },
    checkActive(item) {
      return this.tags.some((e) => e === item.id);
    },
  },
};
</script>

<style scoped lang="scss">
.sub-item-filter {
  cursor: pointer;
  &:hover {
    background-color: #EFEFEF;
  }
  &.active {
    background-color: #EFEFEF;
  }
}
.count {
  background-color: #C1BFBF;
  border-radius: 70%;
  padding: 2px 4px;
  color: #f9f9f9;
  min-width: 32px;
  &.active {
    background-color: #F89234;
  }
}
.quick-filter-container {
  width: 100%;
  background: white;
  overflow: auto;
}
.quick-filter-btn {
  border-top: 8px solid #F89234;
  height: 40px;
  width: fit-content;
  background-color: #EFEFEF;
  color: #4e4e4e;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  opacity: 0.5;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  padding: 0 20px;
  &.active {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    background-color: white;
    opacity: 1;
  }
}
</style>
